// Dependencies
import * as React from 'react'
import { forwardRef } from 'react'

// Internals
import FormProvider from '../contexts/form'

import type { PaymentFormProps } from './types'

const PaymentForm = forwardRef<HTMLDivElement, PaymentFormProps>(
  (
    {
      applicationId,
      cardTokenizeResponseReceived,
      locationId,
      children,
      formProps = {
        'aria-label': 'Payment form',
        id: 'rswps-form',
      },
      overrides,
      ...props
    },
    ref,
  ) => {
    return (
      <FormProvider
        {...props}
        applicationId={applicationId}
        cardTokenizeResponseReceived={cardTokenizeResponseReceived}
        locationId={locationId}
        overrides={overrides}
      >
        <div data-testid="rswps-form" {...formProps} ref={ref} role="form">
          {children}
        </div>
      </FormProvider>
    )
  },
)

PaymentForm.displayName = 'SquarePaymentForm'

export default PaymentForm
export * from './types'
